import PropTypes from 'prop-types';
import React from 'react';

import { kilofy } from 'shared/functions';

// eslint-disable-next-line import/no-default-export
export default class SalaryFormatter extends React.PureComponent {
  static propTypes: any;

  render() {
    const { salary, withCurrency, currencyValue } = this.props as any;

    if (!salary || !Object.keys(salary || {}).filter((item) => item !== 'metadata').length) {
      return null;
    }

    return (
      <span>
        {withCurrency && <span className="salary-currency">{currencyValue && translate(currencyValue)}</span>}
        {salary.min && (
          <span className="salary-min-max">
            {kilofy(salary.min)} - {kilofy(salary.max)}
          </span>
        )}
        {salary.value && <span className="salary-value"> {kilofy(salary.value)}</span>}
        {salary.period && (
          <span className="salary-period" style={{ marginLeft: '5px' }}>
            {translate('per')} {salary.period.name}
          </span>
        )}
      </span>
    );
  }
}

SalaryFormatter.propTypes = {
  salary: PropTypes.object,
  withCurrency: PropTypes.bool,
};
